import { simpleStrHash } from 'utils/stringUtils';

import * as localStorage from 'utils/local-storage';

const DEALERS_BANNERS_STORAGE_KEY = 'dealersBanners';

export const getDealersGroupName = (groupIds, dealersGroupArr) => {
  if (!Array.isArray(groupIds)) {
    return null;
  }

  const dealersGroupMap = new Map(dealersGroupArr.map((g) => [g.id, g.name]));

  for (const id of groupIds) {
    if (dealersGroupMap.has(id)) {
      return dealersGroupMap.get(id);
    }
  }

  return null;
};

const getBannerKey = (groupName, userId) => {
  return `mainDealersGroupBanner_${groupName}_${simpleStrHash(userId)}}`;
};

export const setBannerState = (groupName, userId) => {
  if (!groupName || !userId) {
    return;
  }

  const bannersState = localStorage.getItem(DEALERS_BANNERS_STORAGE_KEY) || {};
  const bannerKey = getBannerKey(groupName, userId);

  bannersState[bannerKey] = {
    isHidden: true,
    hiddenDate: new Date().toISOString(),
  };

  localStorage.saveItem(DEALERS_BANNERS_STORAGE_KEY, bannersState);
};

export const shouldShowBanner = (groupName, userId, bannerTimeOut = 5) => {
  if (!groupName || !userId) {
    return false;
  }

  const bannerKey = getBannerKey(groupName, userId);
  const bannersState = localStorage.getItem(DEALERS_BANNERS_STORAGE_KEY) || {};
  const state = bannersState[bannerKey];

  // Если нет состояния - показываем баннер, работает при самом первом запуске
  if (!state) {
    return true;
  }

  // Если не скрыт - показываем баннер, работает при последующих запусках, когда state уже существует
  if (!state.isHidden) {
    return true;
  }

  try {
    const hiddenDate = new Date(state.hiddenDate);

    if (isNaN(hiddenDate.getTime())) {
      return true;
    }

    const currentDate = new Date();
    const daysDiff = (currentDate - hiddenDate) / (1000 * 60 * 60 * 24);

    return daysDiff >= bannerTimeOut;
  } catch (error) {
    console.error('Error in shouldShowBanner:', error);
    return true;
  }
};
